import { all } from 'redux-saga/effects'
import { subscriptionSaga } from './subscription/saga'

export function* socketSaga() {
  yield all([subscriptionSaga()])
}
